import { config } from './config'
import { authService } from './auth'
export type ChatEndpoint = 'chat' | 'invoke' | 'query' | 'agentfront'
interface AgentResponse {
  traceId?: string
  orchestratorMetadata?: {
    mcpCalls?: any[]
    totalLatencyMs?: number
    simulatedConfidenceScore?: number
    tenantId?: string
  }
  data: {
    response: string
    intent: string
    intentConfidence?: number
    mcpCallsSummary?: any[]
    actionsTaken?: any[]
    structuredData?: any
    suggestedFollowups?: string[]
    dataSources?: string[]
    warnings?: string[]
    sessionId?: string
    context?: any
  }
}
class ApiService {
  private async getHeaders() {
    const token = await authService.login()
    return {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'x-tenant-id': config.api.tenantId,
    }
  }

  /**
   * Resolve full URL based on selected endpoint mode:
   * 'chat'   → https://wnatdv7qzb.execute-api.us-east-1.amazonaws.com/v1/agent/chat
   * 'query'  → https://wnatdv7qzb.execute-api.us-east-1.amazonaws.com/v1/agent/query
   * 'invoke' → https://zc436z6iwd.execute-api.us-east-1.amazonaws.com/v1/agent/invoke  (legacy)
   */
  private resolveUrl(endpoint: ChatEndpoint): string {
    switch (endpoint) {
      case 'chat':
        return `${config.api.newBaseUrl}/v1/agent/chat`
      case 'query':
        return `${config.api.newBaseUrl}/v1/agent/query`
      case 'invoke':
      default:
        return `${config.api.baseUrl}/v1/agent/invoke`
    }
  }
  async invokeAgent(
    message: string,
    sessionId?: string,
    history?: any[],
    endpoint: ChatEndpoint = config.chat.defaultEndpoint,
    projectKey?: string,
  ) {
    const headers = await this.getHeaders()
    const body: any = {
      message,
      projectKey: projectKey || config.api.projectKey,
    }
    if (sessionId) body.sessionId = sessionId
    // Temporarily disabled: backend returns 500 with conversationHistory
    // if (history && history.length > 0) body.conversationHistory = history

    const url = this.resolveUrl(endpoint)
    console.log(`[API] Calling /${endpoint}:`, url)
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
      })
      if (!response.ok) {
        throw new Error(`API Error: ${response.status} ${response.statusText}`)
      }
      return response.json() as Promise<AgentResponse>
    } catch (error: any) {
      console.error(`[API] /${endpoint} failed:`, error)
      if (error instanceof TypeError && error.message === 'Failed to fetch') {
        throw new Error(
          `Error de conexión con /${endpoint}. Verificá la URL o intentá otro endpoint.`,
        )
      }
      throw error
    }
  }
  async getSprintStatus(sprintId: string) {
    const headers = await this.getHeaders()
    const url = `${config.api.baseUrl}/v1/agent/sprint/${sprintId}/status`
    const response = await fetch(url, {
      method: 'GET',
      headers,
    })
    if (!response.ok) throw new Error(`API Error: ${response.statusText}`)
    return response.json()
  }
}
export const apiService = new ApiService()
